export default __webpack_public_path__ + "static/media/safe7-intro-pl.4f5d5096.png";